// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit'

import { modalRef } from '@/components/modal/Modal'

export const NAME = 'modal'

const getUpdateFn = () => {
  // eslint-disable-next-line no-console
  const { update } = modalRef?.current || { update: () => console.error('No modal ref...') }
  return update
}

export const openModal = (content, isWide) => dispatch => {
  const update = getUpdateFn()
  update(content, isWide)
  dispatch(activate())
}

export const closeModal = () => (dispatch, getState) => {
  dispatch(deactivate())
  setTimeout(() => {
    const update = getUpdateFn()
    !getIsActive(getState()) && update(null)
  }, 1500)
}

const initialState = {
  isActive: false,
}

export const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    activate: state => {
      state.isActive = true
    },
    deactivate: state => {
      state.isActive = false
    },
  },
})

export const { activate, deactivate } = actions

const getState = state => state[NAME]

export const getIsActive = state => getState(state).isActive

export default reducer
